
  (() => {
  function retryPool(callback, retryTime = 1e3, retryFrequency = 25) {
    if (retryTime <= 0)
      return;
    setTimeout(() => {
      retryPool(callback, retryTime - retryFrequency, retryFrequency);
    }, retryFrequency);
    callback();
  }
  function waitFor(condition, callback, endTime = 1e4, pollInterval = 25) {
    if (condition()) {
      callback(condition());
    } else if (endTime > 0) {
      setTimeout(() => {
        waitFor(condition, callback, endTime - pollInterval, pollInterval);
      }, pollInterval);
    }
  }

  function mutationObs(target, callback, config = {
    attributes: true,
    childList: true,
    subtree: true
  }) {
    if (typeof target === "string")
      target = document.querySelector(target);
    new MutationObserver(callback).observe(target, config);
  }

  var q = (a, b) => b ? a.querySelector(b) : document.querySelector(a);
  var qa = (a, b) => b ? a.querySelectorAll(b) : document.querySelectorAll(a);
  function insertEle(target, position, element, checkEle) {
    if (!checkEle) {
      typeof element === "string" ? target.insertAdjacentHTML(position, element) : target.insertAdjacentElement(position, element);
    }
  }

  var info = {
    SITE: "xbx",
    ID: "51",
    VAR: "v1"
  };
  var freeShaker = ''

  function log() {
    window.runningExperiments[`${info.SITE}-${info.ID}`].logs.push([
      ...arguments
    ]);
  }
  var pdp_base_html = null;

  function addContent(ID2, base) {
    base.classList.add(`${ID2}-content`);
    insertEle(
      base,
      "beforeend",
      `<div class="${ID2}-popup" state="hidden">
      <div class="wrapper">
        <div class="loader"></div>
        <div class="content"></div>
      </div>
    </div>`,
      q(base, `.${ID2}-popup`)
    );
    qa(base, ".grid__item").forEach((ele) => {
      // console.log("ele:",ele.classList.contains("mix_match_item"));
      const gridItemMeta = ele.querySelector('.grid-product__meta-btn');
      if (!q(ele, `.${ID2}-btn`) && !q(ele, ".grid-product__tag--sold-out") && !ele.classList.contains("mix_match_item")) {
        insertEle(
          gridItemMeta,
          "beforeend",
          `<div class="${ID2}-btn btn btn--full btn--no-animate add-to-cart">
          In den Warenkorb
        </div>`
        );
        log("content-added", ele);
      }
    });
  }

  function openModalPopup(popupEle, modalPopup) {
    modalPopup.classList.add("active");
    log(modalPopup, "modal-popup-open");
    insertEle(popupEle, "beforeend", modalPopup);
  }
  function closeModalPopup(popupEle, modalPopup) {
    modalPopup.classList.remove("active");
    log(modalPopup, "modal-popup-close");
    setTimeout(() => {
      insertEle(q(popupEle, ".content"), "beforeend", modalPopup);
    }, 400);
  }

  var addImgSize = (img) => {
    const listOfLink = img.split(".");
    const afterDot = listOfLink.pop();
    return listOfLink.join(".") + "_300x." + afterDot;
  };
  function fetchAndUpdate(popupEle, link, hideBundleCrossedPrice = false) {
    log("opening-modal-fetching-pdp", link);
    fetch(link).then((r) => r.text()).then((text) => {
      if (popupEle.getAttribute("state") === "hidden" || popupEle.getAttribute("state") === "closing")
        return;
      const base = new DOMParser().parseFromString(text, "text/html");
      pdp_base_html = base;
      const varSelectorEle = q(
        base,
        "[data-product-blocks] > .main-variants-block"
      );
      const fakeVarSelectorEle = q(
        base,
        "[data-product-blocks] > .fake_variant_picker"
      );
      const allPopupBundle = qa(
        base,
        "[data-section-type='bundle-popup']"
      );
      const allPopupFake = qa(
        base,
        ".product-section [data-section-type='fake-popup']"
      );
      const bundleInfo = q( base,".fake-bundle-items");

      const spoon_svg = q( base,".price_per_portion_svg")

      q(base, "[free-shaker]") ? freeShaker = q(base, "[free-shaker]").getAttribute('free-shaker') : freeShaker = '';
      spoon_svg ? insertEle(q(popupEle,".XBX-10__spoon-wrapper"), "afterbegin", spoon_svg.innerHTML) : null;
      console.log("spoon_svg", spoon_svg);
      // console.log("allPopupFake", allPopupFake);
      console.log("base", base);
      // console.log("fakeVarSelectorEle",fakeVarSelectorEle);

      if (bundleInfo){
        insertEle(
          q(popupEle, ".content"),
          "afterbegin",
          bundleInfo
        );
      }

      q(popupEle, ".btn.visit-page").href = link;
      if (q(base, ".product-bundle-components"))
        insertEle(
          q(popupEle, ".content"),
          "afterbegin",
          `<script class="bundle-component" type="application/json">[
            ${[...qa(base, "[data-bundle-component-id]")].map(
            (e) => `{
                "id": ${e.getAttribute("data-bundle-component-id")},
                "name": "${e.getAttribute("data-variant-component") || e.getAttribute("data-fake-component-handle") || ""}"
              }`
          ).join(",")}
          ]<\/script>`
        );
      const varriantData = JSON.parse(
        q(base, "[data-variant-json]").textContent
      );
      // console.log("fakeVarSelectorEle",fakeVarSelectorEle);
      // console.log("bundleInfo:",bundleInfo);
      if(fakeVarSelectorEle && bundleInfo ){
        popupEle.setAttribute("data-bundle-exist",'true');
      }else{
        popupEle.setAttribute("data-bundle-exist",'false');
      }

      if (varSelectorEle && varriantData[0].featured_image && !fakeVarSelectorEle) {

        varriantData.forEach((item, index) => {
          insertEle(
            q(popupEle, ".content > .top-content > .description"),
            "beforebegin",
            `<img
              class="${index === 0 ? "active" : ""}"
              value="${item.title}"
              src="${addImgSize(item.featured_image.src)}"/>`,
            q(
              popupEle,
              `.content > .top-content > .description > img[value="${item.title}"]`
            )
          );
          log("product-variant", item);
        });
      }else {
        insertEle(
          q(popupEle, ".content > .top-content > .description"),
          "beforebegin",
          `<img class="active" src="${q(
            base,
            "[data-product-photos] > .product-main-slide img[data-src]"
          ).getAttribute("data-src").replace("{width}x", "300x")}"/>`,
          q(popupEle, ".content > .top-content > .description > img.active")
        );
        log("single-product-image", varriantData);
      }
      q(popupEle, ".content > .top-content > .description > .title").innerHTML = q(base, "h1.product-single__title").innerHTML;
      q(
        popupEle,
        ".content > .top-content > .description > .price-container > .price"
      ).setAttribute(
        "data-price",
        q(base, ".price-container > [data-product-price]").getAttribute(
          "data-price"
        )
      );
      q(
        popupEle,
        ".content > .top-content > .description > .price-container > .price > .current"
      ).innerHTML = q(
        base,
        ".price-container > [data-product-price]"
      ).textContent;
      if (q(base, ".price-container [data-compare-price]")) {
        const oldPriceElement = q(
          popupEle,
          ".content > .top-content > .description > .price-container > .price > .old"
        );
        oldPriceElement.innerHTML = q(
          base,
          ".price-container [data-compare-price]"
        ).textContent;

        // Hide old price if metafield is true
        if (hideBundleCrossedPrice) {
          oldPriceElement.style.display = 'none';
        }
      }
      insertEle(
        q(popupEle, ".content > .top-content > .description"),
        "beforeend",
        q(base, "[data-unit-price-wrapper]"),
        q(
          popupEle,
          ".content > .top-content > .description > [data-unit-price-wrapper]"
        )
      );
      waitFor(
        () => q(
          popupEle,
          ".content > .top-content > .description > [data-unit-price-wrapper] a"
        ),
        (ele) => {
          ele.removeAttribute("href");
        }
      );

      document.querySelector("#show_fsd_buttons") && q(base, '.free_shaker_details:not(.usp__wrapper)') && insertEle(
        q(popupEle, ".content > .top-content > .description"),
        "beforeend",
        q(base, ".free_shaker_details:not(.usp__wrapper)"),
        q(
          popupEle,
          ".content > .top-content > .description > .free_shaker_details"
        )
      );

        // const popupEle = q(
        //   base,
        //   ".custom-popup-style"
        // );
        // console.log(popupEle);
      fakeVarSelectorEle && insertEle(
        q(popupEle, ".content > .visit-page"),
        "beforebegin",
        fakeVarSelectorEle,
        q(popupEle, ".content > .sort-items__button--popup")
      );
      fakeVarSelectorEle && qa(document, ".sort-items__button--popup").forEach( item => {
        q(item, ".sort-items__wrapper").querySelectorAll("*").forEach( child => {
          child.addEventListener('click', () => {
            item.querySelector('.title__wrapper .color_name').innerHTML = child.querySelector('.color_name')?.innerHTML
            item.removeAttribute('open')
            item.querySelector('.selected').classList.remove('selected');
            child.classList.add('selected');
          })
        })
      })

      varSelectorEle && insertEle(
        q(popupEle, ".content > .visit-page"),
        "beforebegin",
        varSelectorEle,
        q(popupEle, ".content > .variant-with-bundle")
      );


      // Handle new style variant dropdowns in popup
      handleVariantDropdownSelect(popupEle, base);

      insertEle(
        q(popupEle, ".content > .visit-page"),
        "beforebegin",
        q(base, "[data-product-blocks] .quantityDiscountImages"),
        q(popupEle, ".content > .quantityDiscountImages")
      );

      // q(base, '[data-section-type="bundle-popup"]') && insertEle(
      //   q(popupEle, ".content > .visit-page"),
      //   "beforebegin",
      //   q(base, '[data-section-type="bundle-popup"]'),
      //   q(popupEle, "[data-section-type='bundle-popup']")
      // );

      q(base, '[data-section-type="shipping-popup"]') && insertEle(
        q(popupEle, ".content > .visit-page"),
        "beforebegin",
        q(base, '[data-section-type="shipping-popup"]'),
        q(popupEle, ".content > [data-section-type='shipping-popup']")
      );

      allPopupBundle.forEach(node => {
        q(popupEle, ".content > .visit-page").parentNode.insertBefore(node, q(popupEle, ".content > .visit-page"));
      });


      allPopupFake.forEach(node => {
        q(popupEle, ".content > .visit-page").parentNode.insertBefore(node, q(popupEle, ".content > .visit-page"));
      });

      document.querySelector("#show_ppp_buttons") && q(base, '#general_price_per_portion') && insertEle(
        q(popupEle, ".content > .visit-page"),
        "beforebegin",
        q(base, '#general_price_per_portion'),
        q(popupEle, ".content > .price-per-portion")
      );
      changePricePerPortion(popupEle, 1);

      popupEle.setAttribute("state", "active");
      log("pdp-dom", base);
    });

    // Create a function to check the condition and remove the element if needed
    const checkAndRemoveFakeVariantPicker = () => {
      const fakeVariantPicker = q(document, ".fake_variant_picker");
      const hasOnlyDefaultVariant = q(document, ".has-only-default-variant");

      if (fakeVariantPicker && hasOnlyDefaultVariant) {
        fakeVariantPicker.remove();
        observer.disconnect();
      }
    };

    // Create a MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          checkAndRemoveFakeVariantPicker();
        }
      }
    });

    // Start observing the document body for added nodes
    observer.observe(document.body, { childList: true, subtree: true });

    // Optionally, you can perform an initial check in case the element already exists
    checkAndRemoveFakeVariantPicker();

  }
  function openPopup(popupEle, link, hideBundleCrossedPrice = false) {
    popupEle.setAttribute("state", "opening");
    // Store the metafield value on the popup element for other functions to access
    popupEle.setAttribute("data-hide-bundle-crossed-price", hideBundleCrossedPrice ? "true" : "false");
    q(popupEle, ".content").innerHTML = `
    <svg class="cross"  xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path d="M19.8531 19.2008C19.8984 19.243 19.9348 19.294 19.96 19.3506C19.9853 19.4072 19.9988 19.4683 19.9999 19.5303C20.001 19.5923 19.9896 19.6538 19.9664 19.7113C19.9432 19.7688 19.9086 19.821 19.8648 19.8648C19.821 19.9086 19.7688 19.9432 19.7113 19.9664C19.6538 19.9896 19.5923 20.001 19.5303 19.9999C19.4683 19.9988 19.4072 19.9853 19.3506 19.96C19.294 19.9348 19.243 19.8984 19.2008 19.8531L13.9885 14.6416L8.77618 19.8531C8.68869 19.9346 8.57297 19.979 8.4534 19.9769C8.33383 19.9748 8.21974 19.9264 8.13518 19.8418C8.05062 19.7572 8.00218 19.6431 8.00007 19.5236C7.99796 19.404 8.04235 19.2883 8.12387 19.2008L13.3354 13.9885L8.12387 8.77618C8.04235 8.68869 7.99796 8.57297 8.00007 8.4534C8.00218 8.33383 8.05062 8.21974 8.13518 8.13518C8.21974 8.05062 8.33383 8.00218 8.4534 8.00007C8.57297 7.99796 8.68869 8.04235 8.77618 8.12387L13.9885 13.3354L19.2008 8.12387C19.2883 8.04235 19.404 7.99796 19.5236 8.00007C19.6431 8.00218 19.7572 8.05062 19.8418 8.13518C19.9264 8.21974 19.9748 8.33383 19.9769 8.4534C19.979 8.57297 19.9346 8.68869 19.8531 8.77618L14.6416 13.9885L19.8531 19.2008Z" fill="#333333"/>
    </svg>
    <div class="top-content">
      <div class="description">
        <h5 class="title"></h5>
        <div class="price-container text-md">
          <div class="price">
            <div class="current bolder"></div>
            <div class="old"></div>
          </div>
          <div class="price-per-portion">
            <div class="XBX-10__pdp">
              <div class="XBX-10__container text-sm">
                <div class="XBX-10__spoon-wrapper">
                </div>

                <p class="XBX-10__pdp__text">
                  nur CHF <span class="portion_price"></span> pro Portion
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a href="" class="btn btn--full btn--no-animate visit-page btn--secondary">Mehr Infos zum Produkt</a>
    <div class="btn btn--full btn--no-animate add-to-cart">In den Warenkorb</div>
  `;
    fetchAndUpdate(popupEle, link, hideBundleCrossedPrice);
  }
  function closePopup(popupEle) {
    popupEle.setAttribute("state", "closing");
    setTimeout(() => {
      popupEle.setAttribute("state", "hidden");
      q(popupEle, ".wrapper > .content").innerHTML = "";
    }, 500);
    log("popup-closing");
  }

  var handleVariantDropdownSelect = (popupEle, base) => {
    qa(popupEle, ".dropdown-new-style-enable .sort-items__button--popup").forEach( dropdown => {
      const options = dropdown.querySelectorAll('.sort-items__option');
      const dropdownId = dropdown.id;
      
      if (dropdownId) {
        const selectId = dropdownId.replace('sort-items__button--popup-', 'SingleOptionSelector-');
        const selectElement = q(popupEle, `#${selectId}`) || q(document, `#${selectId}`);
        
        options.forEach(option => {
          option.addEventListener('click', function() {
            const selectedValue = this.getAttribute('value');
            if (!selectedValue || !selectElement) return;
            
            // Update select value
            selectElement.value = selectedValue;
            
            // Trigger change event
            const changeEvent = new Event('change', { bubbles: true });
            selectElement.dispatchEvent(changeEvent);
            
            // Update visual state - remove selected from all
            dropdown.querySelectorAll('.sort-items__option').forEach(opt => {
              opt.classList.remove('selected');
              const svg = opt.querySelector('svg');
              if (svg) svg.style.opacity = '0';
            });
            
            // Add selected to clicked option
            this.classList.add('selected');
            const svg = this.querySelector('svg');
            if (svg) svg.style.opacity = '1';
            
            // Update displayed title
            const titleElement = dropdown.querySelector('.title__wrapper .color_name') || dropdown.querySelector('.color_name');
            if (titleElement) {
              titleElement.textContent = selectedValue;
            }
            // Call changeVariant to update images and prices
            changeVariant(popupEle, selectElement);
            // Close dropdown
            dropdown.removeAttribute('open');
          });
        });
      }
    });
  }

  var changeWeight = (popupEle, quantity) => {
    const weightEle = q(popupEle, ".discountImages > .size_wrapper_discount_info > .size-no > .weight");
    const portionEle = q(popupEle, ".discountImages > .size_wrapper_discount_info > .size-no > .portions");

    if (weightEle) {
      weightEle.innerHTML = (Math.round(parseFloat(q(popupEle, ".discountImages > .size_wrapper_discount_info > .size-no").dataset.singleWeight) * quantity)).toString().replace(".", ",");
      // console.log("weight-changed", weightEle);
    }
    if (portionEle) {
      portionEle.innerHTML = parseInt(
        q(popupEle, ".discountImages > .size_wrapper_discount_info > .size-no").dataset.singlePortion
      ) * quantity;
      // console.log("portion-changed", portionEle);
    }
  };
  var changePrice = (popupEle, quantity) => {
    const discountVal = [-1, 0, 5, 10, 15];
    if (quantity < 1 || quantity >= discountVal.length) {
      console.error("Invalid quantity");
      return;
    }

    const singlePrice = parseInt(
      q(popupEle, ".wrapper > .content > .top-content > .description > .price-container > .price").dataset.price
    ) / 100;

    const discountAmount = (singlePrice * discountVal[quantity]) / 100;

    const currentPrice = ((singlePrice - discountAmount) * quantity).toFixed(2).toString().replace(",", ".");
    q(popupEle, ".wrapper > .content > .top-content > .description > .price-container > .price > .current").innerHTML = `CHF ${currentPrice}`;

    const oldPriceElement = q(popupEle, ".wrapper > .content > .top-content > .description > .price-container > .price > .old");
    const hideBundleCrossedPrice = popupEle.getAttribute("data-hide-bundle-crossed-price") === "true";

    if (discountAmount === 0) {
      oldPriceElement.innerHTML = "";
    } else {
      const oldPrice = (singlePrice * quantity).toFixed(2).toString().replace(",", ".");
      oldPriceElement.innerHTML = `CHF ${oldPrice}`;
    }

    // Hide old price if metafield is true
    if (hideBundleCrossedPrice) {
      oldPriceElement.style.display = 'none';
    }

    log("single-price", singlePrice, "discount-amount", discountAmount);
  };
  var changeUnitprice = (popupEle, quantity) => {
    const discountVal = [-1, 0, 5, 10, 15];
    if (quantity < 1 || quantity >= discountVal.length) {
      console.error("Invalid quantity");
      return;
    }

    const unitPrice = Number(q(popupEle, ".current_unit_price").dataset.unitPrice.replace(',', '.'));
    const discount = (100 - discountVal[quantity]) / 100

    const newUnitPrice = (unitPrice * discount).toLocaleString('de-CH', { maximumFractionDigits: 2,minimumFractionDigits: 2 })

    q(popupEle, ".current_unit_price").innerHTML = `CHF ${newUnitPrice}`;
  }
  var changePricePerPortion = (popupEle, quantity) => {
    let base_portion = q(popupEle, ".wrapper > .content > #general_price_per_portion");
    let popup_price_per_portion = q(popupEle, ".wrapper > .content > .top-content > .description > .price-container > .price-per-portion");
      console.log("base_portion", base_portion);

    if(base_portion != null){
      popup_price_per_portion.style.display = "block";
      let base_price_per_portion = parseFloat(base_portion.dataset.portion.replace(',', '.'));
      let current_price = parseFloat(q(popupEle, ".wrapper > .content > .top-content > .description > .price-container > .price > .current").textContent.split('CHF ')[1].replace(',', '.'));
      let new_price = (current_price / (parseInt(quantity) * base_price_per_portion)).toFixed(2);
      console.log("current_price", current_price);
      console.log("new_price", new_price);
      q(popupEle, ".wrapper > .content > .top-content > .description > .price-container > .price-per-portion > .XBX-10__pdp > .XBX-10__container > .XBX-10__pdp__text > .portion_price").textContent = new_price.replace(",", ".");
    }else{
      popup_price_per_portion.style.display = "none";
    }
  }

  function changeQuantity(popupEle, base) {
    q(popupEle, ".discountImages > ul > li.active").classList.remove("active");
    base.classList.add("active");
    changePrice(popupEle, base.dataset.no);
    changeWeight(popupEle, base.dataset.no);
    changeUnitprice(popupEle, base.dataset.no);
    console.log("quantity-changed", base);
    console.log("quantity-changed base.dataset.no: ", base.dataset.no);

    changePricePerPortion(popupEle, base.dataset.no);
  }
  function changeVariantFake(popupEle, base){
    setTimeout(()=>{
      const data = JSON.parse(
        q(
          popupEle,
          ".wrapper > .content > .quantityDiscountImages > .product-block:not(.discountImages) [data-variant-json]"
        ).innerHTML
      );

      let variantItem = getFakeVariantData(data);
      if(variantItem.featured_image){
        q(popupEle, `.top-content > img`).setAttribute("src",variantItem.featured_image.src );
      }

      const formatter = new Intl.NumberFormat('de-CH', {
        style: 'currency',
        currency: 'CHF',
      });

      if(variantItem.price){
        const priceValue = variantItem.price / 100
        q(
          popupEle,
          ".wrapper > .content > .top-content > .description > .price-container > .price > .current"
        ).innerHTML = formatter.format(priceValue);
      }
      if(variantItem.compare_at_price){
        const priceValue = variantItem.compare_at_price / 100
        const oldPriceElement = q(
          popupEle,
          ".wrapper > .content > .top-content > .description > .price-container > .price > .old"
        );
        oldPriceElement.innerHTML = formatter.format(priceValue);

        // Hide old price if metafield is true
        const hideBundleCrossedPrice = popupEle.getAttribute("data-hide-bundle-crossed-price") === "true";
        if (hideBundleCrossedPrice) {
          oldPriceElement.style.display = 'none';
        }
      }
    })

  }

  function changeVariant(popupEle, base) {
    const oldActiveImage = q(
      popupEle,
      ".wrapper > .content > .top-content > img.active"
    );
    const newActiveImage = q(
      popupEle,
      `.wrapper > .content > .top-content > img[value="${base.value}"]`
    );
    console.log("change variant",base);
    if (newActiveImage) {
      console.log("change image");
      oldActiveImage.classList.remove("active");
      newActiveImage.classList.add("active");
      console.log("variation-changed:", base.value);
    }
    // Find the matching option element in the select (which has data-variant-price)
    const selectOption = base.querySelector(`option[value="${base.value}"]`);
    if (selectOption) {
      base = selectOption;
    }
    if(base.getAttribute("data-variant-price")!=""){
      // handle price change for normal products
      console.log("change price");
      const priceValue = base.getAttribute("data-variant-price");
      q(
        popupEle,
        ".wrapper > .content > .top-content > .description > .price-container > .price > .current"
      ).innerHTML = priceValue;
      console.log("change variant price:", priceValue);
    }
  }

  var getFakeVariantData = (data) => {
    let targetTitle = [];
    const objVariants = JSON.parse(document.querySelector('.fake-bundle-items').innerHTML);
    const selector = '.variant__picker--wrapper-' + objVariants.items?.guide?.guide?.split(',')[1];
    let added_guide = false;
    qa(document, '.fake_variant_picker .sort-items__wrapper').forEach( item => {
      if(item.closest(".repeated_popup")){
        if(q(document, selector)){
          targetTitle.push(q(document, `${selector} input:checked`)?.value);
          added_guide = true;
        }
      }
      targetTitle.push(q(item, '.selected').getAttribute('value'));
    })
    if(q(document, selector) && !added_guide ){
      targetTitle.push(q(document, `${selector} input:checked`)?.value)
    }
    targetTitle = targetTitle.join(' / ')
      variantItem = data.find(item => item.title === targetTitle);
      return variantItem
  }

  var getVariantNumber = (popupEle) => {
    const data = JSON.parse(
      q(
        popupEle,
        ".wrapper > .content > .quantityDiscountImages > .product-block:not(.discountImages) [data-variant-json]"
      ).innerHTML
    );
    let variant = data[0].id;
    if(q(document, ".fake_variant_picker")){
      let variantItem = getFakeVariantData(data);
      variant = variantItem.id;
    } else if (data.length > 1) {
      console.log("data", data);

      // Check if product uses select elements (new style dropdowns)
      const selectElements = qa(popupEle, ".wrapper > .content > .main-variants-block select[data-variant-input]");
      console.log("selectElements", selectElements);
      if (selectElements && selectElements.length > 0) {
        // Build variant title from select values (format: "Option1 / Option2 / Option3")
        const selectedValues = Array.from(selectElements)
          .map(select => select.value)
          .filter(value => value); // Remove empty values
        console.log("selectedValues", selectedValues);
        if (selectedValues.length > 0) {
          const variantTitle = selectedValues.join(' / ');
          const matchedVariant = data.find(e => e.title === variantTitle);
          console.log("matchedVariant", matchedVariant);
          if (matchedVariant) {
            variant = matchedVariant.id;
          } else {
            console.warn("Variant not found for title:", variantTitle);
          }
        }
      } else {
        // Fall back to input:checked for old style variant pickers
        const checkedInput = q(
          popupEle,
          ".wrapper > .content > .main-variants-block .variant-input > input:checked"
        );

        if (checkedInput) {
          const matchedVariant = data.find(
            (e) => e.title === checkedInput.value
          );

          if (matchedVariant) {
            variant = matchedVariant.id;
          }
        }
      }
    }
    return variant;
  };
  var getQuantityNumber = (popupEle) => {
    const quantitySelectorEle = q(
      popupEle,
      ".wrapper > .content > .quantityDiscountImages > .product-block.discountImages > ul > li.active"
    );
    let quantity = 1;
    if (quantitySelectorEle)
      quantity = parseInt(quantitySelectorEle.dataset.no);
    return quantity;
  };
  var getPayloadData = (id, quantity, popupEle) => {
    const PDPurl = q(popupEle, ".btn.visit-page").href;
    const bundleComponents = q(popupEle, ".bundle-component");

    const data = {
      "items": [
        {
          id,
          quantity
        }
      ]
    };


    if (bundleComponents && q(popupEle, "[data-variant-input]:checked") || q(document,".fake-bundle-items")) {
      const _bundle_set = `bundle_set_${Math.floor(Math.random() * 1e5)}`;
      let extraItems = "";
      // console.log("bundle_items", q(popupEle, "[data-variant-input]:checked")?.dataset.variantBundleIncludesIds);
      data.items[0].properties = {
        _bundle_main: "true",
        _bundle_set,
        _bundle_items: q(popupEle, "[data-variant-input]:checked")?.dataset.variantBundleIncludesIds,
        _bundle_set_title: q(popupEle, ".title").textContent.trim(),
        _bundle_item_handle: q(popupEle, "[data-variant-input]:checked")?.dataset.variantBundleIncludes,
        _bundle_item_prices: 'noprices',
        _bundle_item_real_prices: 'noprices',
      };
      if(q(document, ".fake_variant_picker") ||q(document,".fake-bundle-items") ){
        const dataProduct = JSON.parse(
          q(
            popupEle,
            ".wrapper > .content > .quantityDiscountImages > .product-block:not(.discountImages) [data-variant-json]"
          ).innerHTML
        );

       let bundle_items = "";
       let bundle_items_handle = "";

       const objVariants = JSON.parse(document.querySelector('.fake-bundle-items').innerHTML);;

        // add the energy product
        let drowpdownvalues = document.querySelectorAll('.fake_variant_picker .sort-items__wrapper');
        if (drowpdownvalues.length > 0) {
          let energieDropdown = document.querySelector('.fake_variant_picker .energie_popup .sort-items__wrapper');
          if(energieDropdown?.querySelector('.selected')&& objVariants.items.energie){
            let energie = energieDropdown.querySelector('.selected').getAttribute('value').split(',')[0].replaceAll(' ','-').toUpperCase();
            bundle_items += objVariants.items.energie[energie].split(',')[0] + ',';
            bundle_items_handle += objVariants.items.energie[energie].split(',')[1] + ',';
            // console.log('energieDropdown addition: ', objVariants.items.energie[energie].split(',')[0]);
          }
          // add the fake products
          let fakeDropdowns = document.querySelectorAll('.fake_variant_picker .fake_popup');
          fakeDropdowns.forEach(element => {
            let fakeDropdown = element.querySelector('.sort-items__wrapper');
            if(fakeDropdown?.querySelector('.selected') && objVariants.items.metafield){
              let metafield = fakeDropdown.querySelector('.selected').getAttribute('value').split(',')[0].replaceAll(' ','-').toUpperCase();
              // console.log('fake metafield', metafield);
              bundle_items_handle += objVariants.items.metafield[metafield].split(',')[1] + ',';
              bundle_items += objVariants.items.metafield[metafield].split(',')[0] + ',';
              // console.log('fake addition: ', objVariants.items.metafield[metafield].split(',')[0]);
            }
          });
          // repeated dropdown
          let repeatedDropdown = document.querySelector('.fake_variant_picker .repeated_popup .sort-items__wrapper');
          if(repeatedDropdown?.querySelector('.selected') && objVariants.items.repeated){
            let repeated = repeatedDropdown.querySelector('.selected').getAttribute('value').split(',')[0].replaceAll(' ','-').toUpperCase();
            // console.log('rick repeated', repeated);
            bundle_items_handle += objVariants.items.repeated[repeated].split(',')[1] + ',';
            bundle_items += objVariants.items.repeated[repeated].split(',')[0] + ',';
            // console.log('repeated addition: ', objVariants.items.repeated[repeated].split(',')[0]);
          }
        }

        // add the normal products
        if(objVariants.items.standard != null){
          let standardValues = Object.entries(objVariants.items.standard);
          let metafieldValues = Object.values(objVariants.items.metafield).map(value => value.split(',')[0]);
          for (let [key, value] of standardValues) {
              if (!metafieldValues.includes(value.split(',')[0])) {
                  bundle_items += value.split(',')[0] + ',';
                  bundle_items_handle += value.split(',')[1] + ',';
              }
          }
        }

        // add the guide
        if (document.querySelector('input[value="OHNE GUIDE"]')?.checked && objVariants.items.guide) {
          // console.log('rick', bundle_items_handle, objVariants.items.guide.guide.split(',')[1].toString())
          bundle_items_handle = bundle_items_handle.replace(objVariants.items.guide.guide.split(',')[1].toString(),'')
          bundle_items = bundle_items.replace(objVariants.items.guide.guide.split(',')[0].toString(),'')
        }

        if (drowpdownvalues.length > 0) {
          data.items[0].properties._bundle_items = bundle_items;
          data.items[0].properties._bundle_item_handle = bundle_items_handle;
        }

        if(!document.querySelector('.main-variants-block')){
            data.items[0].properties._bundle_items = bundle_items;
            data.items[0].properties._bundle_item_handle = bundle_items_handle;
        }

      }else {
        JSON.parse(bundleComponents.innerHTML).forEach((item) => {
          if (!q(popupEle, "[data-variant-input]:checked") || item.name === "" || item.name === q(popupEle, "[data-variant-input]:checked").getAttribute("value").toUpperCase())
            extraItems += item.id + ",";
        });
        data.items[0].properties._bundle_items = `${extraItems.slice(0, -1)}`;
      }

    }
    if(document.querySelector('[data-section-type="shaker-popup"]') != null){
      // check if the product is one of the excluded shaker items or cart has any
      let removed_shaker_manually_Ids = getCookie("removed_shaker_manually_Ids");
          console.log("removed_shaker_manually_Ids: ",removed_shaker_manually_Ids );
      if(removed_shaker_manually_Ids != null){
          console.log("id: ",id );
        if(removed_shaker_manually_Ids.includes(id)){
          window.enable_shaker_popup = "false";
          freeShaker = '';
          console.log("current item is excluded: ",id );
        }
      }
    }
    if (freeShaker != '' && !q('form#CartDrawerForm [data-gift-cart-item]') && window.shaker_choice != "true" && sessionStorage.getItem("shakerRemoved") != "true" ) {
      // check if the shaker product should be added automatically or with a choice
      console.log("add free shaker from CP");
      data.items.unshift({ id: freeShaker, quantity: 1 });
    }
    return JSON.stringify(data);
  };
  function addToCart_default(popupEle, atcBtn) {
    const variant = getVariantNumber(popupEle);
    const quantity = getQuantityNumber(popupEle);
    const headers = {'Content-Type': 'application/json','X-Requested-With': 'XMLHttpRequest'};
    const body = getPayloadData(variant, quantity, popupEle);
    atcBtn.classList.add("btn--loading");
    log("atc-quantity", quantity, "atc-variation", variant);
    fetch("/cart/add.js", {
      method: "POST",
      headers,
      credentials: 'same-origin',
      body
    }).then((res) => res.json()).then(() => {
      document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
      document.dispatchEvent(new CustomEvent("cart:open"));
      if (!q("body").classList.contains("stop-cart-drawer"))
        closePopup(popupEle);
      if(document.querySelector(".x-sell__wrapper")!= null && window.xSellProduct && parseInt(variant) == parseInt(window.xSellProduct.xSellId)){
        document.querySelector(".x-sell__wrapper").style.display="none";
      }
    });
  }

  function onClick(ID2) {
    q("body").addEventListener("click", (e) => {
      const base = q(`.${ID2}-popup`);
      const popupState = base.getAttribute("state");
      const variantModalPopup = qa(base, '[data-section-type="bundle-popup"]');
      const variantModalPopupOne = variantModalPopup[0]?.getAttribute("id").includes("2-") ? variantModalPopup[1] : variantModalPopup[0];
      const variantModalPopupTwo = variantModalPopup[0]?.getAttribute("id").includes("2-") ? variantModalPopup[0] : variantModalPopup[1];

      const fakeVariantModalPopups = Array.from(qa(base, '[data-section-type="fake-popup"]')); // Convert NodeList to an array
      const categorizedPopups = fakeVariantModalPopups.reduce((acc, popup) => {
          const id = popup?.getAttribute("id");
          if (id.includes("2-")) {
              acc.two = popup;
          } else if (id.includes("3-")) {
              acc.three = popup;
          } else {
              acc.one = popup;
          }
          return acc;
      }, { one: null, two: null, three: null });
      const { one: fakeVariantModalPopupOne, two: fakeVariantModalPopupTwo, three: fakeVariantModalPopupThree } = categorizedPopups;
      // console.log("fakeVariantModalPopup:",fakeVariantModalPopup);
      // console.log("fakeVariantModalPopupOne:",fakeVariantModalPopupOne);
      // console.log("fakeVariantModalPopupTwo:",fakeVariantModalPopupTwo);
      // console.log("fakeVariantModalPopupThree:",fakeVariantModalPopupThree);

      const shippingModalPopup = q(base, '[data-section-type="shipping-popup"]');
      const targetPopup = e.target.closest(`.${ID2}-popup`);
      const targetPopupWrapper = e.target.closest(`.${ID2}-popup > .wrapper`);
      const targetVariantModal = e.target.closest(
        `.${ID2}-popup [data-section-type="bundle-popup"]`
      );
      const targetVariantModalFakepopup = e.target.closest(
        `.${ID2}-popup [data-section-type="fake-popup"]`
      );
      const targetVariantModalWrapper = e.target.closest(
        `.${ID2}-popup > [data-section-type="bundle-popup"] > .modal__inner`
      );
      const targetVariantModalWrapperFakepopup = e.target.closest(
        `.${ID2}-popup > [data-section-type="fake-popup"] > .modal__inner`
      );
      const targetShippingModal = e.target.closest(
        `.${ID2}-popup [data-section-type="shipping-popup"]`
      );
      const targetShippingModalWrapper = e.target.closest(
        `.${ID2}-popup > [data-section-type="shipping-popup"] > .modal__inner`
      );
      const targetPopupOpenBtn = e.target.closest(`.${ID2}-btn`);
      const targetPopupCloseBtn = e.target.closest(
        `.${ID2}-popup > .wrapper > .content > .cross`
      );
      const targetquantityBtn = e.target.closest(
        `.${ID2}-popup > .wrapper > .content > .quantityDiscountImages > .discountImages > ul > li`
      );
      const targetVariantBtn = e.target.closest(
        `.${ID2}-popup > .wrapper > .content > .main-variants-block .variant-input > input`
      );
      const targetVariantBtnFake = e.target.closest(
        `.${ID2}-popup > .wrapper > .content > .fake_variant_picker .sort-items__wrapper > div`
      );
      const targetATC = e.target.closest(
        `.${ID2}-popup > .wrapper > .content > .add-to-cart`
      );
      const targetVariantModalOpenBtn = e.target.closest(
        `.${ID2}-popup > .wrapper .js-modal-open-bundle-popup-modal`
      );
      const targetVariantModalOpenBtnTwo = e.target.closest(
        `.${ID2}-popup > .wrapper .js-modal-open-bundle-popup-modal-2`
      );
      const targetFakeVariantOneModalOpenBtn = e.target.closest(
        `.${ID2}-popup > .wrapper .js-modal-open-fake-popup-1-modal`
      );
      const targetFakeVariantTwoModalOpenBtn = e.target.closest(
        `.${ID2}-popup > .wrapper .js-modal-open-fake-popup-2-modal`
      );
      const targetFakeVariantThreeModalOpenBtn = e.target.closest(
        `.${ID2}-popup > .wrapper .js-modal-open-fake-popup-3-modal`
      );
      const targetVariantModalCloseBtn = e.target.closest(
        `.${ID2}-popup > [data-section-type="bundle-popup"] .modal__close`
      );
      const targetVariantModalCloseBtnFakePopup = e.target.closest(
        `.${ID2}-popup > [data-section-type="fake-popup"] .modal__close`
      );
      const targetShippinModalgOpenBtn = e.target.closest(
        `.${ID2}-popup > .wrapper .js-modal-open-shipping-popup-modal`
      );
      const targetShippingModalCloseBtn = e.target.closest(
        `.${ID2}-popup > [data-section-type="shipping-popup"] .modal__close`
      );
      if (popupState === "hidden") {
        if (targetPopupOpenBtn) {
          // Read the metafield attribute from the grid item
          const gridItem = targetPopupOpenBtn.closest(".grid__item");
          const metaBtn = q(gridItem, ".grid-product__meta-btn");
          const hideBundleCrossedPrice = metaBtn && metaBtn.getAttribute("data-hide-bundle-crossed-price") === "true";

          openPopup(
            base,
            q(gridItem, ".grid-product__link").href,
            hideBundleCrossedPrice
          );
        }
      } else if (popupState !== "hidden" && popupState !== "closing") {
        if (targetPopupCloseBtn || targetPopup && !targetPopupWrapper && !targetVariantModal && !shippingModalPopup?.classList.contains('active') && !fakeVariantModalPopupOne?.classList.contains('active') && !fakeVariantModalPopupTwo?.classList.contains('active') && !fakeVariantModalPopupThree?.classList.contains('active'))
          closePopup(base);
        else if (targetquantityBtn)
          changeQuantity(base, targetquantityBtn);
        else if (targetVariantBtn || targetVariantBtnFake)
          q(document, ".fake_variant_picker") ? changeVariantFake(base, targetVariantBtn): changeVariant(base, targetVariantBtn);
        else if (targetATC)
          addToCart_default(base, targetATC);
        else if (targetVariantModalOpenBtn && variantModalPopupOne && !variantModalPopupOne.classList.contains("active"))
          openModalPopup(base, variantModalPopupOne);
        else if (targetVariantModalOpenBtnTwo && variantModalPopupTwo && !variantModalPopupTwo.classList.contains("active"))
          openModalPopup(base, variantModalPopupTwo);
        else if (targetFakeVariantOneModalOpenBtn && fakeVariantModalPopupOne && !fakeVariantModalPopupOne.classList.contains("active"))
          openModalPopup(base, fakeVariantModalPopupOne);
        else if (targetFakeVariantTwoModalOpenBtn && fakeVariantModalPopupTwo && !fakeVariantModalPopupTwo.classList.contains("active"))
           openModalPopup(base, fakeVariantModalPopupTwo);
        else if (targetFakeVariantThreeModalOpenBtn && fakeVariantModalPopupThree && !fakeVariantModalPopupThree.classList.contains("active"))
          openModalPopup(base, fakeVariantModalPopupThree);
        else if ((targetVariantModalCloseBtnFakePopup || targetVariantModalFakepopup && !targetVariantModalWrapperFakepopup) && fakeVariantModalPopupOne && fakeVariantModalPopupOne.classList.contains("active"))
          closeModalPopup(base, fakeVariantModalPopupOne);
        else if ((targetVariantModalCloseBtnFakePopup || targetVariantModalFakepopup && !targetVariantModalWrapperFakepopup) && fakeVariantModalPopupTwo.classList.contains("active"))
          closeModalPopup(base, fakeVariantModalPopupTwo);
        else if ((targetVariantModalCloseBtnFakePopup || targetVariantModalFakepopup && !targetVariantModalWrapperFakepopup) && fakeVariantModalPopupThree && fakeVariantModalPopupThree.classList.contains("active"))
          closeModalPopup(base, fakeVariantModalPopupThree);
        else if ((targetVariantModalCloseBtn || targetVariantModal && !targetVariantModalWrapper) && variantModalPopupOne && variantModalPopupOne.classList.contains("active"))
          closeModalPopup(base, variantModalPopupOne);
        else if ((targetVariantModalCloseBtn || targetVariantModal && !targetVariantModalWrapper) && variantModalPopupTwo && variantModalPopupTwo.classList.contains("active"))
          closeModalPopup(base, variantModalPopupTwo);
        else if (targetShippinModalgOpenBtn && shippingModalPopup && !shippingModalPopup.classList.contains("active"))
          openModalPopup(base, shippingModalPopup);
        else if ((targetShippingModalCloseBtn || targetShippingModal && !targetShippingModalWrapper) && shippingModalPopup && shippingModalPopup.classList.contains("active"))
          closeModalPopup(base, shippingModalPopup);

      }
    });
  }

  var ID = `${info.SITE}-${info.ID}`;
  window.runningExperiments = window.runningExperiments || {};
  window.runningExperiments[ID] = {
    name: "Add quick ATC button on PLPs",
    logs: []
  };
  var mainFunc = () => {
    retryPool(
      () => addContent(
        ID,
        q("#CollectionAjaxResult > #CollectionAjaxContent > .grid.grid--uniform")
      )
    );
  };
  waitFor(
    () => q("#CollectionAjaxResult > #CollectionAjaxContent > .grid.grid--uniform"),
    () => {
      q("body").classList.add(ID);
      mainFunc();
      onClick(ID);
      mutationObs(q("#CollectionAjaxResult > #CollectionAjaxContent"), () => {
        if (!q(`.${ID}-content`) && q(
          "#CollectionAjaxResult > #CollectionAjaxContent > .grid.grid--uniform"
        ))
          mainFunc();
      });
    }
  );
})();